import React from "react";
import goodflipSmartScaleImg from "src/assets/images/devices/goodflip-smart-scale.png";
import goodflipCgmReaderImg from "src/assets/images/devices/goodflip-cgm-reader.png";

const Template: React.FC<{
  title: string;
  titleClassName?: string;
  description: string | React.ReactNode | React.ReactElement;
  image?: string | React.ReactElement;
}> = ({ title, titleClassName, description, image }) => {
  const images = {
    "goodflip-smart-scale": goodflipSmartScaleImg,
    "goodflip-cgm-reader": goodflipCgmReaderImg,
  };
  return (
    <div>
      <div className="flex items-center justify-center">
        {image ?? (
          <img
            src={images[image as unknown as keyof typeof images]}
            alt="Smart Scale"
            className="w-28 h-28 object-contain"
          />
        )}
      </div>
      <h1
        className={`text-xl font-bold text-center mt-6 leading-relaxed ${titleClassName}`}
      >
        {title}
      </h1>
      <p className="text-center text-[var(--text-secondary)] mt-6 w-full">
        {description}
      </p>
    </div>
  );
};

export default Template;
